module.exports = __webpack_public_path__ + "img/588x310-01.33c19c6b.png";